import React, { Fragment, ReactNode } from "react";
import { Pagination, PaginationProps } from "antd";

export interface PaginateListProps<T> {
  items: T[];
  renderItem: (item: T) => ReactNode;
  currentPage: number;
  total: number;
  pageSize?: number;
  onChangePage: PaginationProps["onChange"];
}

export function PaginateList<T>({
  items,
  renderItem,
  currentPage,
  total,
  pageSize = 10,
  onChangePage,
}: PaginateListProps<T>) {
  return (
    <div className="self-stretch flex flex-col justify-start items-start gap-[5px] md:gap-12">
      <div className="grid grid-cols-2 md:grid-cols-5 gap-x-[15px] gap-y-[20px] md:gap-5 w-full">
        {items.map((item, idx) => (
          <Fragment key={idx}>{renderItem(item)}</Fragment>
        ))}
      </div>
      <Pagination
        current={currentPage}
        onChange={onChangePage}
        total={total}
        pageSize={pageSize}
        showSizeChanger={false}
        className="w-full justify-center"
      />
    </div>
  );
}
